import { Link } from "react-router-dom";

export default function NexusLogo({ size = 34, withText = true, className = "", to = "/" }) {
  return (
    <Link to={to} className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="nexus-logo">
      <span
        className="relative inline-flex items-center justify-center"
        style={{ width: size, height: size }}
        aria-hidden
      >
        <svg
          width={size} height={size}
          viewBox="0 0 64 64" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            {/* Ring: cyan → violet → magenta */}
            <linearGradient id="nl-ring" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#22D3EE" />
              <stop offset="55%" stopColor="#7B4DFF" />
              <stop offset="100%" stopColor="#E040FB" />
            </linearGradient>
            {/* N: blue → magenta */}
            <linearGradient id="nl-n" x1="18" y1="14" x2="46" y2="50" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#3DB6FF" />
              <stop offset="55%" stopColor="#8B5CFF" />
              <stop offset="100%" stopColor="#E040FB" />
            </linearGradient>
            {/* Play */}
            <linearGradient id="nl-play" x1="46" y1="14" x2="58" y2="26" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#8B5CFF" />
              <stop offset="100%" stopColor="#E040FB" />
            </linearGradient>
            <filter id="nl-glow" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="1.6" result="b" />
              <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
            </filter>
          </defs>

          {/* Speech-bubble ring */}
          <g filter="url(#nl-glow)">
            <path
              d="M32 6c14.36 0 26 11.64 26 26S46.36 58 32 58c-3.31 0-6.47-.62-9.38-1.75l-8.68 3.45c-1.36.54-2.72-.82-2.18-2.18l3.45-8.68C10.62 45.93 6 39.5 6 32 6 17.64 17.64 6 32 6z"
              stroke="url(#nl-ring)" strokeWidth="2.6" fill="none" strokeLinejoin="round"
            />
          </g>

          {/* Orbit dots (nexus) */}
          <circle cx="41" cy="18" r="1.5" fill="#7B4DFF" />
          <circle cx="20" cy="42" r="1.3" fill="#22D3EE" />
          <circle cx="47" cy="40" r="1.1" fill="#E040FB" />

          {/* Stylized N */}
          <path
            d="M20 46 V20 L44 46 V20"
            stroke="url(#nl-n)"
            strokeWidth="5.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />

          {/* Broadcasting waves + play */}
          <g stroke="url(#nl-play)" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.9">
            <path d="M50 22 Q54 26 50 30" />
            <path d="M53 19 Q59 26 53 33" />
          </g>
          <path
            d="M46 19 L54 24 L46 29 Z"
            fill="url(#nl-play)"
            stroke="url(#nl-play)"
            strokeWidth="1"
            strokeLinejoin="round"
          />
        </svg>
      </span>

      {withText && (
        <span className="font-display font-bold tracking-[0.16em] text-[15px] leading-none uppercase whitespace-nowrap">
          <span className="text-foreground">Nexus</span>{" "}
          <span className="nx-text-gradient">Live</span>
        </span>
      )}
    </Link>
  );
}
